import { schema } from 'normalizr';

export const link = new schema.Entity(
  'links',
  {},
  {
    processStrategy: ({
      children,
      noindex,
      nofollow,
      status,
      id,
      name,
      url,
      sort,
      parrentId,
    }) => ({
      id,
      name,
      url,
      sort,
      parrentId,
      rel: `${parseInt(noindex, 10) ? 'noindex, ' : ''}${
        parseInt(nofollow, 10) ? 'nofollow' : ''
      }`,
      active: !!parseInt(status, 10),
      children: (children || []).map(
        ({
          noindex: childNoindex,
          nofollow: childNofollow,
          status: childStatus,
          id: childId,
          name: childName,
          url: childUrl,
          sort: childSort,
          parrentId: childParrentId,
        }) => ({
          id: childId,
          name: childName,
          url: childUrl,
          sort: childSort,
          parrentId: childParrentId,
          rel: `${parseInt(childNoindex, 10) ? 'noindex, ' : ''}${
            parseInt(childNofollow, 10) ? 'nofollow' : ''
          }`,
          active: !!parseInt(childStatus, 10),
        })
      ),
    }),
  }
);

export const seoLinks = [link];

export default seoLinks;
